/**
 * A function similar to numpy's arange function that generates a range of numbers from
 * [start, stop) with a given step size.
 */
export function arange(
  start: number,
  stop: number,
  step: number = 1
): number[] {
  if (step === 0) {
    throw new Error('Step cannot be zero.')
  }

  const range: number[] = []

  // Populate the range array with values
  if (step > 0) {
    for (let value = start; value < stop; value += step) {
      range.push(value)
    }
  } else {
    // For a negative step, decrement from start to stop
    for (let value = start; value > stop; value += step) {
      range.push(value)
    }
  }

  return range
}
